import { KeyboardArrowRightOutlined } from '@mui/icons-material'
import { motion } from 'framer-motion'
import React from 'react'
import "./nextButtonMobile.css"
const NextButtonMobile = () => {
  return (
    <motion.div className="mobilenext"
      initial={{x: "100vw"}}
      animate={{x: 0}}
      transition={{type: "spring", duration: 1, delay: 1.2}}
    >
        <div className="mobilenext-wrapper">
            <KeyboardArrowRightOutlined className="mnext-icon"/>
        </div>
    </motion.div>
  )
}

export default NextButtonMobile